export default "/images/vendor/flag-icon-css/flags/4x3/eh.svg?b5abdd6ce0be2cb4d9b3e53e7007aae8";